<template>
    <div>
        <div v-if="isFreePlan||isTrialPlan">
            <v-btn :class="isExpiredAccount?'orange':'white'" outline small title="Click to view plan options">
                <span :class="isExpiredAccount?'orange--text':'white--text'">{{ accountName }}</span>
            </v-btn>
            <!-- <v-dialog v-model="dialogUpgrade" width="700">   
                <upgrade :dialogUpgrade.sync="dialogUpgrade"></upgrade>
            </v-dialog> -->
        </div>
        <div v-if="isPaymentOverdue" @click="dialogOkOnly=true">
            <v-btn class="warning" small>
                Payment Overdue
            </v-btn>
        </div>
        <v-dialog v-model="dialogOkOnly" persistent width="600">
            <ok-only :msg="dialogOkOnlyMsg" :dialogOkOnly.sync="dialogOkOnly" @ok="handleOkOnly"></ok-only>
        </v-dialog>
    </div>
</template>
<script>
import companyAccount from '@/common/companyAccountTypes'
export default {
    data() {
        return {
            dialogUpgrade: false,
            dialogOkOnly: false,
            dialogOkOnlyMsg: `Your account has a past due balance. Please settle your payment to continue using SweldoNow. Unpaid accounts may be temporarily suspended.`
        }
    },
    components: {
        // 'upgrade': () => import('@/components/Common/Upgrade'),
        'ok-only': () => import('@/components/BasicPopups/OkOnly')
    },
    methods: {
        // showPlanDetails() {
        //     this.dialogUpgrade = true
        // }
        handleOkOnly() {
            this.$router.push('/company/billing')
        }
    },
    computed: {
        accountName() {
            return companyAccount.planName()
        },
        isFreePlan() {
            return companyAccount.isFreePlan()
        },
        isTrialPlan() {
            return companyAccount.isTrialPlan()
        },
        isExpiredAccount() {
            return companyAccount.isExpiredAccount()
        },
        isPaymentOverdue() {
            return companyAccount.isPaymentOverdue()
        }
    },
    created() {}
}
</script>